import { render, staticRenderFns } from "./LeaveTypeCreateEditModal.vue?vue&type=template&id=2def83f2&scoped=true"
import script from "./LeaveTypeCreateEditModal.vue?vue&type=script&lang=js"
export * from "./LeaveTypeCreateEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2def83f2",
  null
  
)

export default component.exports